<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer001">
<p class="Graphic" lang="en-US"><img alt="" class="_idGenObjectAttribute-1" src="image/9781035842124_Txt.jpg"/></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer003">
<p class="Graphic" lang="en-US"><img alt="" class="_idGenObjectAttribute-1" src="image/9781035842124_Txt2.jpg"/></p>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer004">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781035842131_Epub.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer005">
</div>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer006">
<p class="Heading ParaOverride-1" lang="en-US">Copyright © Robyn Smythe 2024</p>
<p class="Blurb ParaOverride-1" lang="en-US">The right of <span class="CharOverride-1" lang="">Robyn Smythe</span> to be identified as author of this work has been asserted by the author in accordance with sections 77 and 78 of the Copyright, Designs and Patents Act 1988.</p>
<p class="Blurb ParaOverride-1" lang="en-US">All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, electronic, mechanical, photocopying, recording, or otherwise, without the prior permission of the publishers.</p>
<p class="Blurb ParaOverride-1" lang="en-US">Any person who commits any unauthorised act in relation to this publication may be liable to criminal prosecution and civil claims for damages.</p>
<p class="Blurb ParaOverride-1" lang="en-US">A CIP catalogue record for this title is available from the British Library.</p>
<p class="Blurb" lang="en-US">ISBN 9781035842124 (Paperback)</p>
<p class="Blurb ParaOverride-1" lang="en-US">ISBN 9781035842131 (ePub-e-book)</p>
<p class="Blurb ParaOverride-1" lang="en-US">www.austinmacauley.co.uk</p>
<p class="Blurb" lang="en-US">First Published 2024</p>
<p class="Blurb" lang="en-US">Austin Macauley Publishers Ltd<span class="CharOverride-2" lang="">® </span></p>
<p class="Blurb" lang="en-US">1 Canada Square</p>
<p class="Blurb" lang="en-US">Canary Wharf</p>
<p class="Blurb" lang="en-US">London</p>
<p class="Blurb" lang="en-US">E14 5AA</p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer007">
<p class="Dedi ParaOverride-1" lang="en-US">This book is dedicated to all the cat lovers out there around the world.</p>
<p class="Basic-Paragraph ParaOverride-2" lang="en-US"><span class="CharOverride-3" lang="">I hope you enjoy my purr-fect tail.</span></p>
<p class="Basic-Paragraph ParaOverride-3" lang="en-US"><span class="CharOverride-3" lang="">                                                                                                            Rx</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer009">
<p class="Graphic" lang="en-US"><img alt="" class="_idGenObjectAttribute-1" src="image/9781035842124_Txt6.jpg"/></p>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer010">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781035842131_Epub1.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer011">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer012">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781035842131_Epub2.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer013">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer014">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781035842131_Epub3.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer015">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer016">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781035842131_Epub4.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer017">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer018">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781035842131_Epub5.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer019">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer020">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781035842131_Epub6.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer021">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer022">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781035842131_Epub7.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer023">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer024">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781035842131_Epub8.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer025">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer026">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781035842131_Epub9.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer027">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer028">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781035842131_Epub10.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer029">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer030">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781035842131_Epub11.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer031">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer032">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781035842131_Epub12.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer033">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer034">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781035842131_Epub13.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer035">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer036">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781035842131_Epub14.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer037">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer038">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781035842131_Epub15.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer039">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer040">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781035842131_Epub16.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer041">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer042">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781035842131_Epub17.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer043">
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781035842131_Epub.vue?6c65485e